<template>
  <CRow class="mt-5 pt-5 pb-5">
    <CCol sm="12" class="d-flex flex-column mb-3 p-0">
      <h1 class="titlePage font-weight-normal text-capitalize pb-4">
        {{ $t('templates.editTemplate.title') }}
      </h1>
      <a
        v-if="!routeParams"
        @click="back"
        class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer mb-5"
      >
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
        {{ $t('templates.general.editTemplate.back-to-email-list') }}
      </a>
      <a
        v-else
        @click="$router.go(-1)"
        class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer mb-5 text-uppercase"
      >
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
        {{ $t('general.BACK') }}
      </a>
    </CCol>
    <div v-if="loading" style="min-height: 300px" class="d-flex justify-content-center align-items-center dataTable__loading">
      <CSpinner class="my-3" color="primary" />
    </div>

    <CCol v-else sm="12" class="d-flex flex-column mb-5">
      <CRow>
        <CCol sm="12" class="p-0">
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
        <CCol sm="12" md="4" class="p-0">
          <CInput label="Name" v-model="template.name" />
        </CCol>
        <CCol sm="12" class="p-0">
          <p class="pb-2 text-gray-700">Make the last revision in your HTML. You can also add custom fields and add the unsubcribe link.</p>
        </CCol>
      </CRow>
      <CustomFields class="bg-gray-200 px-4 pt-4" @addCustomFieldsToText="addCustomFieldsToText" @addSubscribeText="addSubscribeText" />

      <EditorHtml
        v-if="template"
        :template="template"
        :subscribeText="subscribeText"
        :customField="customField"
        @confirm="sendTemplate"
        class="pb-5"
      />
    </CCol>
  </CRow>
</template>

<script>
import EditorHtml from '@/components/EditorHtml'
import CustomFields from '@/components/CustomFields'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'

const contentTypeEnum = {
  simpleText: 1,
  HTML: 2,
}

export default {
  name: 'EditTemplateEmail',
  components: {
    EditorHtml,
    CustomFields,
    MenssageAlert,
  },
  data() {
    return {
      customField: null,
      subscribeText: '',
      teste: 1,
      messages: [],
      scrollTopInterval: null,
      template: {
        name: null,
        code: null,
      },
      loading: false,
    }
  },
  created() {
    this.getTemplate()
  },

  computed: {
    routeParams() {
      return this.$route.params
    },
  },

  methods: {
    async getTemplate() {
      this.messages = []
      this.loading = true
      try {
        let organizationId = this.$store.state.auth.organizationId
        const TEMPLATE_PAYLOAD = await services.getTemplate(organizationId, this.$route.params.id)
        this.template.name = TEMPLATE_PAYLOAD.data.data.name
        this.template.code = TEMPLATE_PAYLOAD.data.data.htmlContent
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      } finally {
        this.loading = false
      }
    },

    addSubscribeText(content) {
      this.subscribeText = ''
      this.$nextTick(() => {
        this.subscribeText = content
      })
    },

    addCustomFieldsToText(content) {
      this.customField = content
    },

    scrollTop() {
      this.scrollTopInterval = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.scrollTopInterval)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    sendTemplate(template) {
      this.messages = []

      if (template.isInvalid) {
        this.messages.push({
          status: 'danger',
          text: this.$t('templates.editorHtml.unsubscribe'),
        })
        this.scrollTop()
        return
      }

      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .updateTemplateEmail(organizationId, this.$route.params.id, {
          name: this.template.name,
          templateHTMLContent: template.code,
        })
        .then(() => {
          this.loading = false
          this.messages.push({
            status: 'success',
            text: 'Next Step',
          })

          this.$router.push({
            name: 'simple-text',
            params: {
              id: this.$route.params.id,
              contentType: contentTypeEnum.HTML,
              dynamicId: this.$route.params.dynamicId,
              dynamicIndex: this.$route.params.dynamicIndex,
              dynamicDestinationType: this.$route.params.dynamicDestinationType
            },
          })
        })
        .catch((error) => {
          this.template.code = template.code
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || 'ERROR',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    back() {
      this.$router.push({ name: 'template-emails' })
    },
  },
}
</script>

<style></style>
